import { Box, Label } from '@apia/theme';
import { IAttachment } from '../ChatController';
import { FileIcon } from '@apia/icons';
import { observer } from 'mobx-react-lite';
import { IconButton } from '../../../forms';
import { ApiaUtil } from '../../../../objects';
import { Collector } from '@apia/validations';
import { getLabel } from '@apia/util';
import { isImage } from '../util';

export const FileAttachment = observer(
  ({
    attachment,
    onAddDescription,
    onRemove,
  }: {
    attachment: IAttachment;
    onAddDescription?: (a: IAttachment, d: string) => unknown;
    onRemove?: () => unknown;
  }) => {
    const { ref } = ApiaUtil.instance.tooltips.useHover({
      preferredOrientationX: 'left',
      preferredOrientationY: 'top',
      minSize: {
        width: 200,
        height: 400,
      },
      attachToMousePosition: true,
      closeOnMouseLeaveAttachedElement: true,
      children: (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <h1>{attachment.name}</h1>
          <img src={attachment.value}></img>
          {attachment.description && <Label>{attachment.description}</Label>}
        </Box>
      ),
    });

    return (
      <Box
        id={`file_box_${attachment.id}`}
        className="file_box"
        ref={isImage(attachment.value) ? ref : null}
      >
        <FileIcon className="file_box__icon" docName={attachment.name} />
        <Box className="file_box__name" title={attachment.name}>
          {attachment.name}
        </Box>

        {onAddDescription && (
          <IconButton
            icon="Edit"
            className="file_box__description"
            onClick={() => {
              const collector = new Collector();
              collector.add(
                new collector.fields.textarea(
                  'desc',
                  getLabel('lblDesc').text,
                  { initialValue: attachment.description },
                ),
              );
              collector.show({
                onConfirm: (ev): boolean => {
                  if (ev) {
                    onAddDescription(attachment, ev.desc! as string);
                  }
                  return true;
                },
              });
            }}
            variant="icon-only"
          ></IconButton>
        )}
        {onRemove && (
          <IconButton
            icon="Close"
            className="file_box__remove"
            onClick={onRemove}
            variant="icon-only"
          ></IconButton>
        )}
      </Box>
    );
  },
);
